import createDOMPurify, { Config } from "dompurify";

// Use a local instance so hooks don't affect other places
const DOMPurify = createDOMPurify(window);

const config: Config = {
    ALLOWED_TAGS: [
        "a",
        "b",
        "br",
        "em",
        "i",
        "s",
        "span",
        "strong",
        "sub",
        "sup",
        "u",
        "p",
        "blockquote",
        "pre",
        "ul",
        "ol",
        "li",
        "table",
        "thead",
        "tbody",
        "tr",
        "th",
        "td",
    ],
    ALLOWED_ATTR: ["href"], // no "style" => inline styles are stripped
};

// Map sanitize-html transformTags -> DOMPurify hook
const TRANSFORM_TO_SPAN = new Set(["H1", "H2", "H3", "H4", "H5", "H6", "DIV"]);

DOMPurify.addHook("uponSanitizeElement", (_, data) => {
    if (TRANSFORM_TO_SPAN.has(data.tagName)) {
        // Pretend the element is a <span>; DOMPurify will output it as such
        data.tagName = "SPAN";
    }
});

// Keep href only on <a>
DOMPurify.addHook("uponSanitizeAttribute", (node, data) => {
    if (data.attrName === "href" && node.nodeName !== "A") {
        data.keepAttr = false;
    }
});

export function sanitizeClient(html: string) {
    return DOMPurify.sanitize(html, config);
}
